(function ($) {
  'use strict';
  // Get main hero background and each thumbnail.
  const $heroBackground = $('.hero');
  const $heroThumbnails = $('.hero__link-thumbnail');
  const $heroTitle = $('.hero__title');
  const $heroSubtitle = $('.hero__subtitle');

  $heroThumbnails.click((e) => {
    // Get target and its image src that will be swapped in.
    const $target = $(e.currentTarget);
    const targetSrc = $target.attr('hero-src');
    const targetTitle = $target.attr('hero-title');
    const targetSubtitle = $target.attr('hero-subtitle');
    const targetUrl = $target.attr('hero-url');
    const targetAlt = $target.attr('alt');

    /* Fade out existing image.
    Upon full fade out, swap image src.
    Then fade new image in. */
    $heroBackground
      .fadeOut(400, () => {
        $heroBackground.css('background-image', 'url(' + targetSrc + ')');
        $heroBackground.attr('alt', targetAlt);
        $heroTitle.text(targetTitle);
        $heroTitle.attr('href', targetUrl);
        $heroSubtitle.text(targetSubtitle);
      })
      .fadeIn(400);
  });

  $('.hero__link').keypress(function(e) {
    if(e.which === 13) {
      $(e.currentTarget).find('.hero__link-thumbnail').click();
    }
  });
  // Trigger initial click on first thumbnail to initialize the display.
  if ($heroThumbnails.length > 0) {
    $($heroThumbnails[0]).click();
  }
}(jQuery));
